module.exports = __webpack_public_path__ + "img/med-experience-logo-small.3cf74492.png";